import { useState } from "react";
import { Copy, Check, Download } from "lucide-react";
import { toast } from "sonner";
import { SHARE_KIT, HASHTAGS } from "@/lib/press-data";

const CopyBtn = ({ text, testId, label = "Copy" }) => {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setDone(true);
      toast.success("Copied");
      setTimeout(() => setDone(false), 1500);
    } catch {
      toast.error("Couldn't copy. Select the text instead.");
    }
  };
  return (
    <button type="button" onClick={copy} data-testid={testId}
      className="inline-flex items-center gap-1.5 rounded-full border border-[#C86D51]/25 px-3 py-1.5 text-xs font-semibold text-[#2C221E] hover:border-[#9E4429]">
      {done ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />} {label}
    </button>
  );
};

export const ShareKit = () => (
  <div>
    <div className="grid gap-6 md:grid-cols-3">
      {SHARE_KIT.map((k) => (
        <article key={k.id} className="flex flex-col overflow-hidden rounded-[1.5rem] border border-[#C86D51]/15 bg-white/70" data-testid={`share-kit-${k.id}`}>
          <div className="flex aspect-square items-center justify-center bg-[#F4E6DC] p-4">
            <img src={k.file} alt={`Lunelle ${k.format}`} loading="lazy" decoding="async" className="h-full w-full object-contain" />
          </div>
          <div className="flex flex-1 flex-col p-5">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#9E4429]">{k.format}</p>
            <p className="mt-3 flex-1 whitespace-pre-line text-sm leading-relaxed text-[#3D302B]">{k.caption}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              <a href={k.file} download data-testid={`share-kit-${k.id}-download`}
                className="inline-flex items-center gap-1.5 rounded-full bg-[#2C221E] px-3 py-1.5 text-xs font-semibold text-[#FBF5EE] hover:bg-[#9E4429]">
                <Download className="h-3.5 w-3.5" /> Image
              </a>
              <CopyBtn text={`${k.caption}\n\n${HASHTAGS}`} testId={`share-kit-${k.id}-copy`} label="Caption + tags" />
            </div>
          </div>
        </article>
      ))}
    </div>
    <div className="mt-6 flex flex-wrap items-center gap-3 rounded-2xl bg-[#FBF5EE] p-4">
      <p className="flex-1 text-sm text-[#3D302B]" data-testid="share-kit-hashtags">{HASHTAGS}</p>
      <CopyBtn text={HASHTAGS} testId="share-kit-hashtags-copy" label="Copy hashtags" />
    </div>
  </div>
);
